import React, { useEffect, useState } from 'react';
import './manage-mobile-head.styles.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faBarcode,
    faBars, 
    faBriefcase,  
    faGear, 
    faGem, 
    faGlobeAmericas, 
    faHome, 
    faQrcode, 
    faUsers, 
    faX 
} from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { 
    useLocation, 
    useNavigate 
} from 'react-router-dom';
import ManageGameSidebar from '../manage-game-sidebar/manage-game-sidebar.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';
import ManageUserDropdown from './manage-user-dropdown.component';

const ManageMobileHeader = ({ 
    gameData,
    gameElements,
    orgs,
    role
}) => {
    
    const userProfile = useSelector(state => state.userData.userProfile);
    const actionItems = useSelector(state => state.contentData.actionItems);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const [menuOpen, setMenuOpen] = useState(false);
    const [ showDropdown, setShowDropdown ] = useState(false);
    const location = useLocation();
    
    const navigate = useNavigate();
    
    useEffect(() => {
        // document.getElementById('slide-menu').classList.toggle('show');
    }, [menuOpen])

    useEffect(() => {
        setMenuOpen(false);
        setShowDropdown(false);
    }, [location]);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const menuItems = [
        {
            'path': '',
            'label': 'My List'
        }
    ]

    return (
        <div className="manage-mobile-header">
            <div className='mobile-header__top'>
                <div className='mobile-header__menu-left'>
                    <button 
                        className="mobile-header__menu-button" 
                        id="slide-menu" 
                        onClick={toggleMenu} >
                        <FontAwesomeIcon 
                            icon={faBars} />
                    </button>
                    <div className={`mobile-header__logo ${screenSize}`}>
                        <ImageContainer 
                            src={gameData.icon} 
                            alt="game logo" />
                    </div>
                </div>
                <div className='mobile-header__menu-right'>
                    <button 
                        className='g-button text-only icon-button'
                        onClick={() => setShowDropdown(!showDropdown)} >
                        <UserIcon 
                            className='clickable' 
                            profile={userProfile} 
                            reverse={true} 
                            planIcon={true} />
                    </button>
                    <ManageUserDropdown
                        show={showDropdown} />
                </div>       
            </div>
            <div 
                className='mobile-bottom-menu'>
                <FontAwesomeIcon 
                    className={`event-menu-item ${
                        location.pathname === `/manage/${gameData.path}` ? "active" : ""
                    }`} 
                    icon={faHome} 
                    size='xl' 
                    onClick={() => navigate('')} />
                <FontAwesomeIcon 
                    className={`event-menu-item ${
                        location.pathname.includes('/players') ? "active" : ""
                    }`} 
                    icon={faUsers} 
                    size='xl' 
                    onClick={() => navigate('players')} />
                {/* <FontAwesomeIcon 
                    className='event-menu-item menu-groups' 
                    icon={faUsers} 
                    size='lg' 
                    onClick={() => navigate('groups')} /> */}
                <FontAwesomeIcon 
                    className={`event-menu-item ${
                        location.pathname.includes('/elements') ? "active" : ""
                    }`} 
                    icon={faBriefcase} 
                    size='xl' 
                    onClick={() => navigate('elements')} />
                <FontAwesomeIcon 
                    className={`event-menu-item ${
                        location.pathname.includes('/distribute') ? "active" : ""
                    }`} 
                    icon={faGem} 
                    size='xl' 
                    onClick={() => navigate('distribute')} />
                <FontAwesomeIcon 
                    className={`event-menu-item ${
                        location.pathname.includes('/activity') ? "active" : ""
                    }`} 
                    icon={faGlobeAmericas} 
                    size='xl' 
                    onClick={() => navigate('activity')} />
                <FontAwesomeIcon 
                    className={`event-menu-item ${
                        location.pathname.includes('/scan') ? "active" : ""
                    }`} icon={faBarcode} 
                    size='xl' 
                    onClick={() => navigate('scan')} />
            </div>
            <div 
                className={`mobile-header__menu-items ${
                    menuOpen ? "show": ""
                }`}>
                <div 
                    className='close-button' 
                    onClick={() => setMenuOpen(!menuOpen)}>
                    <FontAwesomeIcon 
                        icon={faX} 
                        size='xl' />
                </div>
                <ManageGameSidebar 
                    gameData={gameData} 
                    actionItems={actionItems}
                    gameElements={gameElements}
                    orgs={orgs}
                    role={role} />
            </div>
        </div>
    );
};

export default ManageMobileHeader;